// Otel müsaitliği: bu tarihten önceki check-in'ler kapalı (tüm oteller)
export const HOTEL_AVAILABILITY_START = "2026-08-05";
export const HOTEL_AVAILABILITY_START_TR = "5 Ağustos 2026";

export const isHotelDateBlocked = (dateIso) => !!dateIso && dateIso < HOTEL_AVAILABILITY_START;

// input[type=date] min değeri: bugün mü, müsaitlik başlangıcı mı — hangisi ilerideyse
export const hotelMinDate = () => {
  const today = new Date().toISOString().slice(0, 10);
  return HOTEL_AVAILABILITY_START > today ? HOTEL_AVAILABILITY_START : today;
};

// Önerilecek en yakın müsait tarihler
export const nearestHotelDates = (count = 3) => {
  const start = new Date(HOTEL_AVAILABILITY_START);
  return Array.from({ length: count }, (_, i) =>
    new Date(start.getTime() + i * 86400000).toISOString().slice(0, 10)
  );
};
